import { connect } from 'react-redux';
import {
  currentClientSelector,
  isAdviserArea as selectIsAdviserArea,
  isConsumerArea as selectIsConsumerArea,
} from '../../CommonSelectors/CommonAreaSelector';
import fetchWithDefaults from '../../CommonUtils/fetchWithDefaults';
import { selectedGoal as selectedGoalSelector } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import MobileView from '../../MobileFinancialPlan/MobileActionStepsV2/MobileActionStepsV2View';
import { isCurrentPlanSelector } from '../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import {
  beginAdvisersInTheSameOrganizationRequest,
  endAdvisersInTheSameOrganizationRequest,
  setAPIErrors,
  setSharingSettingsResponse,
} from '../../SharingSettings/SharingSettingsActions';
import {
  clientRelationshipsSelector,
  isLoadingAdvisersInTheSameOrgSelector,
} from '../../SharingSettings/SharingSettingsSelector';
import * as Actions from './ActionStepsV2Actions';
import * as Selectors from './ActionStepsV2Selector';
import View from './ActionStepsV2View';

const mapStateToProps = (state, ownProps) => {
  const goal = ownProps.goal || selectedGoalSelector(state, ownProps);

  const { GoalId: goalId, DebtType } = goal;

  const isAdviserArea = selectIsAdviserArea(state);
  const isConsumerArea = selectIsConsumerArea(state);

  return {
    actionSteps: Selectors.actionStepsSelector(state, ownProps),
    suggestions: Selectors.suggestionsSelector(state, ownProps),
    leftTitle: Selectors.leftTitleSelector(state, ownProps),
    leftButtonText: Selectors.leftButtonTextSelector(state, ownProps),

    rightTitle: Selectors.rightTitleSelector(state, ownProps),
    rightButtonText: Selectors.rightButtonTextSelector(state, ownProps),

    isAddingActionStep: Selectors.isAddingActionStepSelector(state, ownProps),
    addActionStep: Selectors.addActionStepSelector(state, ownProps),

    isAddingSuggestion: Selectors.isAddingSuggestionSelector(state, ownProps),
    addSuggestion: Selectors.addSuggestionSelector(state, ownProps),

    isCurrentPlan: isCurrentPlanSelector(state, ownProps),

    DebtType,
    goalId: ownProps.goalId || goalId,

    advisersInTheSameOrg: isAdviserArea
      ? clientRelationshipsSelector(state)
      : Selectors.selectPlanActionStepsAdvisersAssignees(state, ownProps),
    isLoadingAdvisersInTheSameOrg: isAdviserArea
      ? isLoadingAdvisersInTheSameOrgSelector(state)
      : false,
    currentClient: currentClientSelector(state),
    isAdviserArea,
    isConsumerArea,
    goal,
  };
};

const mapDispatchToProps = dispatch => ({
  getAdvisersInSameOrganization: async clientId => {
    dispatch(beginAdvisersInTheSameOrganizationRequest());

    try {
      const sharingSettingsPromise = await fetchWithDefaults(
        `/Adviser/SharingSettings?clientId=${clientId}`,
      );

      const { success, errors, payload } = await sharingSettingsPromise.json();

      if (success) {
        const { CanTransferOwnership, Relationships } = payload.viewData;
        dispatch(setSharingSettingsResponse(CanTransferOwnership, Relationships));
      } else {
        dispatch(setAPIErrors(errors));
      }
    } catch (exception) {
      dispatch(setAPIErrors([window.ADV.settings.MsgLib.generic_error]));
    } finally {
      dispatch(endAdvisersInTheSameOrganizationRequest());
    }
  },
  onAddActionSteps: (clientId, fpId, goalId, index) => () => {
    dispatch(Actions.onAddActionSteps(clientId, fpId, goalId, index));
  },
  onResetActionSteps: (clientId, fpId, goalId) => () => {
    dispatch(Actions.onResetActionSteps(clientId, fpId, goalId));
  },
  onDeleteActionStep: (clientId, fpId, goalId) => actionStepKey => () => {
    dispatch(Actions.onDeleteActionStep(clientId, fpId, goalId, actionStepKey));
  },
  onChangeActionStepStatus: (clientId, fpId, goalId) => updatedActionStep => () => {
    dispatch(Actions.onChangeActionStepStatus(clientId, fpId, goalId, updatedActionStep));
  },
  onAddSuggestions: (clientId, fpId, goalId) => () => {
    dispatch(Actions.onAddSuggestions(clientId, fpId, goalId));
  },
  onResetSuggestions: (clientId, fpId, goalId) => () => {
    dispatch(Actions.onResetSuggestions(clientId, fpId, goalId));
  },
  onDeleteSuggestion: (clientId, fpId, goalId) => suggestionId => () => {
    dispatch(Actions.onDeleteSuggestion(clientId, fpId, goalId, suggestionId));
  },
  setActionStepIcon: (clientId, fpId, goalId) => icon => () => {
    dispatch(Actions.setActionStepIcon(clientId, fpId, goalId, icon));
  },
  setActionStepText: (clientId, fpId, goalId) => event => {
    dispatch(Actions.setActionStepText(clientId, fpId, goalId, event.target.value));
  },
  onDoneAddingActionStep: (clientId, fpId, goalId, DebtType) => newObject => () => {
    dispatch(Actions.onDoneAddingActionStep(clientId, fpId, goalId, newObject, DebtType));
  },
  onDoneEditingActionStep: (clientId, fpId, goalId) => newObject => () => {
    dispatch(Actions.onDoneEditingActionStep(clientId, fpId, goalId, newObject));
  },
  onCancelAddingActionStep: (clientId, fpId, goalId) => () => {
    dispatch(Actions.onCancelAddingActionStep(clientId, fpId, goalId));
  },
  setSuggestionIcon: (clientId, fpId, goalId) => icon => () => {
    dispatch(Actions.setSuggestionIcon(clientId, fpId, goalId, icon));
  },
  setSuggestionText: (clientId, fpId, goalId) => event => {
    dispatch(Actions.setSuggestionText(clientId, fpId, goalId, event.target.value));
  },
  onDoneAddingSuggestion: (clientId, fpId, goalId, DebtType) => (newObject, suggestions) => () => {
    dispatch(
      Actions.onDoneAddingSuggestion(clientId, fpId, goalId, newObject, suggestions, DebtType),
    );
  },
  onCancelAddingSuggestion: (clientId, fpId, goalId) => () => {
    dispatch(Actions.onCancelAddingSuggestion(clientId, fpId, goalId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);

export const MobileActionStepsV2 = connect(mapStateToProps, mapDispatchToProps)(MobileView);
